const styles = {
  pageWrapperSx: {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#0a0a0a",
    color: "white",
  },

  headerSx: {
    px: { xs: 2, md: 4 },
    py: 1.5,
    borderBottom: "1px solid rgba(255,255,255,0.06)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  headerLabelSx: {
    color: "rgba(255,255,255,0.3)",
    letterSpacing: "0.25em",
    fontSize: "0.62rem",
  },

  logoutButtonSx: {
    color: "rgba(255,255,255,0.4)",
    fontSize: "0.62rem",
    letterSpacing: "0.15em",
    textTransform: "uppercase",
    "&:hover": { color: "white" },
  },

  tabBarSx: {
    borderBottom: "1px solid rgba(255,255,255,0.08)",
    position: "sticky",
    top: 0,
    backgroundColor: "#0a0a0a",
    zIndex: 100,
  },

  tabListSx: {
    px: { xs: 0.5, md: 4 },
    minHeight: 48,
    "& .MuiTab-root": {
      color: "rgba(255,255,255,0.35)",
      fontSize: { xs: "0.68rem", md: "0.75rem" },
      letterSpacing: "0.12em",
      fontWeight: 600,
      textTransform: "uppercase",
      minHeight: 48,
      minWidth: { xs: "auto", md: 110 },
      px: { xs: 1.5, md: 2 },
      "&.Mui-selected": { color: "white" },
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "white",
      height: "1px",
    },
    "& .MuiTabs-scrollButtons": {
      color: "rgba(255,255,255,0.4)",
    },
  },

  tabContentSx: { px: { xs: 2, sm: 3, md: 4 }, py: { xs: 3, md: 4 } },

  tabPanelSx: { p: 0 },
};

export default styles;
